 
import { YonetimAnaSayfaPage } from './../pages/Yonetim/yonetim-ana-sayfa/yonetim-ana-sayfa';
import { HomePage } from './../pages/home/home';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
 
import { CarilerPage } from '../pages/CariIslemleri/cariler/cariler';
import { GirisPage } from '../pages/giris/giris';
import { ReportsPage } from '../pages/Raporlars/reports/reports';
import { RaporanasayfaPage } from '../pages/raporanasayfa/raporanasayfa';
import { KullaniciListePage } from '../pages/Yonetim/kullanici-liste/kullanici-liste';
import { ProgramAyarlariPage } from '../pages/program-ayarlari/program-ayarlari';
import { GunlukGelenUrunlerPage } from '../pages/gunluk-gelen-urunler/gunluk-gelen-urunler';
import { StoklarPage } from '../pages/StokIslemleri/stoklar/stoklar';
import { ToptancilarListesiPage } from '../pages/toptancilar-listesi/toptancilar-listesi';




@Injectable()
export class PagesProvider {
  components = {
    "AnasayfaPage": HomePage,
    "Yonetim": YonetimAnaSayfaPage,

  }
  constructor() {
  }

  menuler() {
    return new Promise((res, err) => {

      var menu = { LEFT_MENU: [], MAIN_MENU: [], KULLANICI_MENU: [], YONETIM_MENU: [], RAPOR_MENU: [], URETICI_MENU: [] };


      menu.LEFT_MENU = this.defaultLeftMenu;
      menu.MAIN_MENU = this.defaultMainMenu;
      menu.KULLANICI_MENU = this.KullaniciMainMenu;
      menu.YONETIM_MENU = this.YonetimMainMenu;
      menu.RAPOR_MENU = this.RaporlarMainMenu;
      menu.URETICI_MENU = this.UreticiMainMenu;


      res(menu);
    })

  }



  defaultLeftMenu = [
    {
      PARENT_SAYFA: { PAGE_NAME: "Yönetim" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Menü", PAGE_ION_ICON: "home", PAGE_COMPONENT: HomePage },
        { PAGE_NAME: "Müşteriler", PAGE_COMPONENT: CarilerPage },
        { PAGE_NAME: "ÇIKIŞ", PAGE_COMPONENT: GirisPage },


      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Belge İşlemleri" }, ALT_SAYFALAR: [

      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Raporlama" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Raporlar", PAGE_ION_ICON: "pie", PAGE_COMPONENT: ReportsPage }

      ]
    },
    {
      PARENT_SAYFA: { PAGE_NAME: "Diğer İşlemler" }, ALT_SAYFALAR: [
        { PAGE_NAME: "Ayarlar", PAGE_ION_ICON: "settings", PAGE_COMPONENT: YonetimAnaSayfaPage },


      ]
    },
  ];



  defaultMainMenu = [
    // { PAGE_NAME: "Palsan Aktarımı", PAGE_ICON: "fa fa-exchange fa-3x", PAGE_COMPONENT: MalkayitListePage, TYPE: "NAV", },
    // { PAGE_NAME: "Palsan Kayıt/Kabul", PAGE_ION_ICON: "train", PAGE_ICON: "fa fa-stack-overflow fa-3x", PAGE_COMPONENT: SatispagePage, TYPE: "NAV", },
     { PAGE_NAME: "Müşteriler", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: CarilerPage, TYPE: "NAV", },
      { PAGE_NAME: "Tüccarlar", PAGE_ICON: "fa fa fa-users fa-3x", PAGE_COMPONENT: ToptancilarListesiPage, TYPE: "NAV", },
  
    
     { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    { PAGE_NAME: "Raporlar", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: RaporanasayfaPage, TYPE: "NAV", },
    //  { PAGE_NAME: "PDF", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: PdftestPage, TYPE: "NAV", },
      { PAGE_NAME: "Yönetim", PAGE_ICON: "fa fa-cogs fa-3x", PAGE_COMPONENT: YonetimAnaSayfaPage, TYPE: "NAV", },
    // { PAGE_NAME: "ÇIKIŞ", PAGE_ICON: "fa fa-sign-out fa-3x", PAGE_COMPONENT: GirisPage, TYPE: "NAV", }

  ];
  KullaniciMainMenu = [
    // { PAGE_NAME: "Palsan Aktarımı", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: MalkayitListePage, TYPE: "NAV", },
    // { PAGE_NAME: "Malzemeler", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: StoklarPage, TYPE: "NAV", },
    // { PAGE_NAME: "ÇIKIŞ", PAGE_ICON: "fa fa-sign-out fa-3x", PAGE_COMPONENT: GirisPage, TYPE: "NAV", }
  ];
  UreticiMainMenu = [
    // { PAGE_NAME: "Bilgilerim", PAGE_ICON: "fa fa-file-text fa-3x", PAGE_COMPONENT: UreticiBilgisiPage, TYPE: "NAV", },
    // { PAGE_NAME: "İşlemlerim", PAGE_ICON: "fa fa-handshake-o fa-3x", PAGE_COMPONENT: StokhareketleriPage, TYPE: "NAV", },
    // { PAGE_NAME: "Depo Kayıtlarım", PAGE_ICON: "fa fa-cubes fa-3x", PAGE_COMPONENT: DepoKayitlariPage, TYPE: "NAV", },
    // { PAGE_NAME: "ÇIKIŞ", PAGE_ICON: "fa fa-sign-out fa-3x", PAGE_COMPONENT: GirisPage, TYPE: "NAV", }
  ];
  YonetimMainMenu = [

    { PAGE_NAME: "Kullanıcılar", PAGE_ICON: "fa fa-user fa-3x", PAGE_COMPONENT: KullaniciListePage, TYPE: "NAV", },
    { PAGE_NAME: "Ayarlar", PAGE_ICON: "fa fa-user fa-3x", PAGE_COMPONENT: ProgramAyarlariPage, TYPE: "NAV", },

    // { PAGE_NAME: "Gelir-Gider", PAGE_ICON: "fa fa-arrows-h fa-3x", PAGE_COMPONENT: GelirgiderPage, TYPE: "NAV", },
    // { PAGE_NAME: "Cari Grupları", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: GrupListesiPage, TYPE: "NAV", },

  ];
  RaporlarMainMenu = [
    { PAGE_NAME: "Gün Sonu Raporu", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: GunlukGelenUrunlerPage, TYPE: "NAV", },
 //   { PAGE_NAME: "Gün Sonu Raporu", PAGE_ICON: "fa fa-pie-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Kasiyer Bazlı Rapor", PAGE_ICON: "fa fa-users fa-3x", PAGE_COMPONENT: KasiyerBazliRaporPage, TYPE: "NAV", },
    // { PAGE_NAME: "Karlılık Raporu", PAGE_ICON: "fa fa-line-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Kategori Bazlı Rapor", PAGE_ICON: "fa fa-bar-chart fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Marka Bazlı Rapor", PAGE_ICON: "fa fa-tags fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Kdv Raporu", PAGE_ICON: "fa fa-percent fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Borçlu Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Alacaklı Cari Hesaplar", PAGE_ICON: "fa fa-briefcase fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
    // { PAGE_NAME: "Gelir/Gider Raporu", PAGE_ICON: "fa fa-arrows-h fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },

    // { PAGE_NAME: "Kasa Durumu", PAGE_ICON: "fa fa-money fa-3x", PAGE_COMPONENT: ReportsPage, TYPE: "NAV", },
  ];


}



// WEBPACK FOOTER //
// ./src/providers/pages-provider.ts